import React from 'react';

import cx from 'classnames';
import { useDispatch } from 'react-redux';

import { switchScheduleItemTypeAction } from 'store/itineraryDetails';
import { SCHEDULE_ITEM_TYPES, SCHEDULE_ITEM_TYPE_TO_LABEL_MAP } from 'utils/itineraryDetails/constants';

import styles from './index.module.css';

function SwitchScheduleItemType({ scheduleItem }) {
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={cx(styles.button, scheduleItem.type === SCHEDULE_ITEM_TYPES.OVERNIGHT && styles.buttonActive)}
        disabled={scheduleItem.type === SCHEDULE_ITEM_TYPES.OVERNIGHT}
        onClick={() => {
          dispatch(switchScheduleItemTypeAction({ type: SCHEDULE_ITEM_TYPES.OVERNIGHT, id: scheduleItem.id }));
        }}
      >
        {SCHEDULE_ITEM_TYPE_TO_LABEL_MAP[SCHEDULE_ITEM_TYPES.OVERNIGHT]}
      </button>
      <button
        type="button"
        className={cx(styles.button, scheduleItem.type === SCHEDULE_ITEM_TYPES.DAY_ROOM && styles.buttonActive)}
        disabled={scheduleItem.type === SCHEDULE_ITEM_TYPES.DAY_ROOM}
        onClick={() => {
          dispatch(switchScheduleItemTypeAction({ type: SCHEDULE_ITEM_TYPES.DAY_ROOM, id: scheduleItem.id }));
        }}
      >
        {SCHEDULE_ITEM_TYPE_TO_LABEL_MAP[SCHEDULE_ITEM_TYPES.DAY_ROOM]}
      </button>
      <button
        type="button"
        className={cx(styles.button, scheduleItem.type === SCHEDULE_ITEM_TYPES.ACTIVITY && styles.buttonActive)}
        disabled={scheduleItem.type === SCHEDULE_ITEM_TYPES.ACTIVITY}
        onClick={() => {
          dispatch(switchScheduleItemTypeAction({ type: SCHEDULE_ITEM_TYPES.ACTIVITY, id: scheduleItem.id }));
        }}
      >
        {SCHEDULE_ITEM_TYPE_TO_LABEL_MAP[SCHEDULE_ITEM_TYPES.ACTIVITY]}
      </button>
    </div>
  );
}

export default SwitchScheduleItemType;
